import { Box, Button, Divider, IconButton} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { Close, Details} from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SearchBar } from "./SearchBar";
import { useDispatch, useSelector } from 'react-redux';
import { getAdvancedSearchList, getBranchList } from "../../actions/commonAction";
import { handleEditOrderModal, showAlertSnackbar } from "../../reducers/uiSlice";
import { getBranchById, getUserPreference } from "../../utilities/common";

import TableTooltip from "../Common/TableTooltip";
import _ from 'lodash';
import moment from "moment";
import { getPartnerList} from "../../actions/mmActions";
import ReactExport from "react-export-excel";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex', 
        flexDirection: 'column', 
        height: 750
    },
    formControl: {
        marginLeft: theme.spacing(2),
        minWidth: 180,
    }
  }));

function AdvancedSearch(props){
    const classes = useStyles()
    const {t} = useTranslation('advancedSearch')
    const dispatch = useDispatch()
    const userPref = getUserPreference()

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    const [branchList, setBranchList] = useState();
    const [loading, setLoading] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false)
    const [list, setList] = useState([])
    const [isSearchMulti, setIsSearchMulti] = useState(false);
    const [partnerList,setPartnerList]=useState();
    const columns = [
        {field: 'id', headerName: t('order_id'), hide: true},
        {
            field: 'order_sn', 
            headerName: t('order_sn'), 
            width: 150, 
            headerAlign: 'center'
        },
        {field: 'tno', headerName: t('tracking_number'), width: 170, headerAlign: 'center'},
        {field: 'consignee', headerName: t('consignee'), width: 150, headerAlign: 'center'},
        {field: 'mobile', headerName: t('consignee_phone'), width: 130, headerAlign: 'center', sortable: false},
        {
            field: 'address', 
            headerName: t('consignee_address'), 
            flex: 2,
            headerAlign: 'center', 
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            )
        },
        {field: 'zipcode', headerName: t('zipcode'), width: 100, headerAlign: 'center', sortable: false},
        {
            field: 'driver_notes', 
            headerName: t('driver_notes'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            )
        },
        {
            field: 'failed_reason', 
            headerName: t('failed_reason'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value?.name} />
            )
        },
        {
            field: 'actions',
            headerName: t('common:actions'),
            sortable: false,
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton
                            size='small'
                            onClick={(e)=>{
                                e.stopPropagation()
                                dispatch(
                                    handleEditOrderModal({
                                        open: true, 
                                        orderIdentifier: params.row.order_sn, 
                                        type: "order_sn"
                                    })
                                )
                            }}
                        >
                            <Details color='primary'/>
                        </IconButton>
                        <IconButton size="small"
                            onClick={(e)=> {
                                e.stopPropagation()
                                removeFromList(params.id)
                            }}
                        >
                            <Close color='error'/>
                        </IconButton>
                    </div>
                )
            }
        }
    ];

    const columnsMulti = [
        {
            field: 'incident_ids',
            headerName: t('incident_ids'), 
            hide: true,
            headerAlign: 'center', 
            width: 200,
            sortable: false,
            renderCell: (params) => (
                 <TableTooltip value={params.value} />
             ),
            align: 'center',
            flex: 1
        },
        {
            field: 'warehouse', 
            headerName: t('warehouse'), 
            width: 150, 
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div>{getBranchById(params.value).short_name}</div>
            ),
            flex: 1
        },
        {
            field: 'tno', 
            headerName: t('tracking_number'), 
            width: 170, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => {
                return (
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(
                            handleEditOrderModal({
                                open: true, 
                                orderIdentifier: params.row.order_sn, 
                                type: "order_sn"
                            })
                        )
                    }}
                >
                    {params.value}
                  </div>
                );
            },
            flex: 1
        },
        {field: 'referer', headerName: t('referer'), width: 150, headerAlign: 'center', align: 'center',flex: 1},
        {
            field: 'address', 
            headerName: t('consignee_address'), 
            headerAlign: 'center', 
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center',
            flex: 1
        },
        {field: 'zipcode', headerName: t('zip'), width: 100, headerAlign: 'center', sortable: false, align: 'center',flex: 1},
        {
            field: 'postscript', 
            headerName: t('order_memo'), 
            headerAlign: 'center', 
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center',
            flex: 1
        },
        {
            field: 'error_message', 
            headerName: t('error_message'), 
            headerAlign: 'center', 
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center',
            flex: 1
        },
        {
            field: 'parcel_scan_time', 
            headerName: t('parcel_scan_time'), 
            width: 200, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            flex: 1
        },
        {field: 'latest_status', headerName: t('latest_status'), width: 150, headerAlign: 'center', align: 'center',flex: 1},
        {
            field: 'latest_update_time', 
            headerName: t('latest_update_time'), 
            width: 200, 
            flex: 1,
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
        },
        {
            field: 'item_description', 
            headerName: t('item_description'), 
            headerAlign: 'center', 
            width: 200,
            flex: 1,
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center'
        },
        {
            field: 'storage_info', 
            headerName: t('storage_info'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center'
        },
        {
            field: 'third_party_sn', 
            headerName: t('third_party_sn'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center'
        },
        {
            field: 'partner_name',
            headerName: t('partner_name'),
            flex: 1,
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            ),
            align: 'center'
        },
        {
            field: 'sender_refer',
            headerName: t('sender_refer'),
            flex: 1,
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            )
        },
        {
            field: 'pack_id',
            headerName: t('pack_id'),
            flex: 1,
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            )
        },
        {
            field: 'shipping_staff_id',
            headerName: t('shipping_staff_id'),
            flex: 1,
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={params.value} />
            )
        }
    ];
    useEffect(() => {
        dispatch(getPartnerList()).then((res) => {
            setPartnerList(res);
        })
            .catch(() => {
                setLoading(false);
            })

    }, []);

    useEffect(() => {
        dispatch(getBranchList()).then((branches) => {
            setBranchList(branches);
        })
            .catch(() => {
                setLoading(false);
            })
    }, [])
    
    useEffect(() => {
        if (props.open) {
            setIsSearchMulti(false);
        }
    }, [props.open])

    return (
        <Box className={classes.container}>
            <SearchBar 
                onSearch={_handleOnSearch}
                resetList={resetList}
                partnerList={partnerList}
                branchList={branchList}
                handleSearchMulti={handleSearchMulti}
                open={props.open}
            />
            <Divider style={{marginTop: 16}}/>
            <Box style={{flex: 1, marginTop: 16}}>
                <DataGrid
                    loading={isDataLoading}
                    alignItems="center"
                    rows={createRows()}
                    columns={isSearchMulti?columnsMulti:columns}
                    disableColumnFilter 
                    disableColumnMenu
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    isRowSelectable={false}
                />
            </Box>
            {
                isSearchMulti &&
                list?.length > 0 &&
                <ExcelFile
                    element={
                        <Button 
                            variant="contained" 
                            color="primary"
                            style={{margin: 20}}
                        >
                            {t('download_all')}
                        </Button>
                    }
                >
                    <ExcelSheet data={createRows()||[]} name="Multi Search">
                        {
                            columnsMulti.map((column) => (
                                <ExcelColumn label={column.headerName} value={column.field}/>
                            ))
                        }
                    </ExcelSheet>
                </ExcelFile>
            }
        </Box>
    )

    function handleSearchMulti(isMulti) {
        setIsSearchMulti(isMulti);
    }

    function _handleOnSearch(warehouse, orderType, searchBy, searchValue, customer, extensionNo){
        let trimStr = searchValue.trim();
        let customerId = customer === 'ALL' ? null : customer;
        if(!trimStr){
            return
        }
        setIsDataLoading(true)
        if (extensionNo === '') {
            extensionNo = -1
        }
        getAdvancedSearchList(warehouse, orderType, searchBy, trimStr, customerId, extensionNo).then((data)=>{
            if(data.length <= 0){
                dispatch(showAlertSnackbar({
                    title: t('advanced_search'), 
                    message: t('dialog:advanced_search_no_order')
                }))
            }
            let input = trimStr.split(',');
            let dataStyled = [];
            if(input.length > 1) {
                for(var i = 0; i < input.length; i++) {
                    data.map((order) => {
                        if(order.tno === input[i]) {
                            dataStyled.push(order);
                        }
                    })
                }
                setList(dataStyled);
            } else {
                addItemToList(list, data)
            }
            setIsDataLoading(false);
        }).catch(error => {
            dispatch(showAlertSnackbar({
                title: t('advanced_search'), 
                message: error.message || t('dialog:general_network_error_message')}))
            setIsDataLoading(false)
        })
    }

    function addItemToList(list, data){
        let result = _.union(list, data)
        setList(result)
    }

    function resetList(){
        setList([])
    }

    function removeFromList(id){
        let newArray = _.filter(list, (item)=>{return item.order_id !== id})
        setList(newArray)
    }

    function timeStampToDate(time){
        return moment.unix(time).format("MMM DD, YYYY - HH:mm:ss");
    }

    function createRows(){
        return list.map((row) => {
            const { order_id, parcel_scan_time, latest_update_time, pack_id, shipping_staff_id, ...rest } = row
            return {
                id: order_id,
                parcel_scan_time: timeStampToDate(parcel_scan_time),
                latest_update_time: timeStampToDate(latest_update_time),
                pack_id: pack_id,
                shipping_staff_id: shipping_staff_id,
                ...rest
            }
        })
    }
}

export default AdvancedSearch
